import React from "react";
import { Route } from "react-router-dom";
import GoogleFontLoader from "react-google-font-loader";
import { DatePickers, Toaster, Tooltips } from "@axum/ax-design";
import Routes from "../routes";
import "../assets/App.css";

const App = (props: any) => {
  return (
    <>
      <GoogleFontLoader
        fonts={[
          {
            font: "Rubik",
            weights: [400, "400i", 500, "500i", 600, "600i", 700, "700i"],
          },
          {
            font: "Inter",
            weights: [400, 500, 600],
          },
        ]}
      />
      <Route path="/" component={Routes} />
      <Toaster label="Notificaciones" />
      <Tooltips />
      <DatePickers />
    </>
  );
};

export default App;
